'use strict'

import React, { useState, useRef, useEffect } from 'react';
import { useFloating, offset, size, shift, arrow } from '@floating-ui/react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames/bind';

import { useClickAway } from '@/views/utils';

import s from './styles.scss';

const sx = cn.bind(s);

const SINGLE_SORT = 'SINGLE_SORT';
const MULTI_SORT = 'MULTI_SORT';

export default ({
	sortMode,
	sortModes,
	setSortMode,
	sort,
	setSort,
	columns,
	setColumns,
}) => {

	const [ menuOpen, setMenuOpen ] = useState(false);

	const clickAwayRef = useRef(null);
	const arrowRef = useRef(null);

	useClickAway(clickAwayRef, () => setMenuOpen(false));

	const onSortModeClick = key => {

		if (key === SINGLE_SORT && sort.length > 1) {

			let first = sort.at(0);

			setSort([ first ]);

			let newColumns = columns.map(c => {
				if (c.key === first.at(0)) {
					return c;
				}
				return { ...c, sort: 0 };
			});

			setColumns(newColumns);
		}

		setSortMode(key);
		setMenuOpen(false);
	};

	const {
		x,
		y,
		reference,
		floating,
		strategy,
		update,
		middlewareData: {
			arrow: {
				x: arrowX,
				y: arrowY,
			} = {}
		},
	} = useFloating({
		placement: 'bottom',
		middleware: [
			offset(8),
			shift(),
			arrow({ element: arrowRef }),
			size({
				apply: (ctx) => {
					const { availableWidth, reference, elements } = ctx;
					Object.assign(elements.floating.style, {
						minWidth: `${ elements.reference.offsetWidth }px`,
					});
				},
			}),
		],
	});

	return (
		<div className={ s.root } ref={ reference } >
			<div className={ s.cont } ref={ clickAwayRef }>
				<div className={ s.label } onClick={ () => setMenuOpen(!menuOpen) } >
					<div className={ s.iconCont }>
						<FontAwesomeIcon icon='arrow-up-a-z' />
					</div>
					<div className={ s.text }>
						Sort
					</div>
					<div className={ s.iconCont }>
						<FontAwesomeIcon icon='caret-down' />
					</div>
				</div>
				{
					menuOpen &&
					<div
						className={ s.menu }
						ref={ floating }
						style={{
							position: strategy,
							top: y ?? 0,
							left: x ?? 0,
							zIndex: 20,
						}}
					>
						<div
							ref={ arrowRef }
							className={ s.arrow }
							style={{
								position: strategy,
								top: arrowY ?? -4,
								left: arrowX ?? 0,
							}}
						/>
						<div className={ s.sortTypes }>
							<table>
								<tbody>
								{ Object.entries(sortModes).map(([ key, val ]) => (
									<tr
										key={ key }
										className={
											sx('sortType', { active: sortMode === key })
										}
										onClick={ () => onSortModeClick(key) }
									>
										<td>
											{
												sortMode === key &&
												<FontAwesomeIcon icon='check' />
											}
											{
												sortMode !== key &&
												<FontAwesomeIcon icon='check' color='#fff'/>
											}
										</td>
										<td className={ s.sortText }>
											{ val }
										</td>
									</tr>
								))}
								</tbody>
							</table>
						</div>
						{
							false && sortMode === MULTI_SORT &&
							<div className={ s.sortList }>
								{ sort.map(([ key, val ]) => (
									<div key={ key } className={ s.sortItem }>
										<div className={ s.colLabel }>
											{ key }
										</div>
										<div className={ s.remove }>
											<FontAwesomeIcon icon='xmark' />
										</div>
									</div>
								))}
							</div>
						}
					</div>
				}
			</div>
		</div>
	);
}
